﻿import {String} from "./Misc.js"
import {UrlHash} from "./Url.js";
import {JQueryTools} from "./JQueryTools.js";
import {DisposableStack} from "./Disposable/DisposableStack";

export class ControlerList {
    public DefaultUrl: string = "/Home/Index";
    static #_instance: ControlerList;
    #items: Array<Controler> = [];
    
    constructor() {
        this.setWindowLocationChangeEvent().then();
    }
    
    public static get Instance(): ControlerList {
        if (this.#_instance == null)
            this.#_instance = new ControlerList();
        return this.#_instance;
    }

    public get Length(): number {
        return this.#items.length;
    }

    public Bind = async (c: Controler) => {
        let el = this.#items.find(x => x.Route == c.Route);

        if (el != null)
            throw new Error("Ce controller existe déjà.");

        this.#items.push(c);
    };

    public HideAll = async () => {
        // todo : Ici, on va dire : 
        // Si Dipose existe, on le fait.
        // Sinon, on supprime le contenu (.remove)
        this.#items.forEach(x => {
            x.DisposableStack.Dispose();
            x.Content.remove();
        });
    }

    /*
     * Charge le contenu définit par l'url/
     * Force : Charge le contenu même s'il existe déjà.
     */
    public Load = async (url: string): Promise<Controler> => {

        url = url.toLowerCase();
        const el = this.#items.find(x => UrlHash.GetPathFromString(x.Route.toLowerCase()) == UrlHash.GetPathFromString(url.toLowerCase()));

        if (el == null)
            throw new Error("Ce controller n'existe pas. La route n'a pas été trouvée parmi les controllers existants.");

        if (el.IsPartial == false) this.HideAll().then();
        let qs = UrlHash.GetQueryString;

        await el.Load(null, qs);

        return el;
    };

    public Navigate = async (url: string) => {
        window.location.hash = url.replace("#", "");
    };

    private setWindowLocationChangeEvent = async () => {

        $(window).off("hashchange");

        $(window).on("hashchange",
            async () => {
                let url = UrlHash.GetRoute;

                if (String.IsNullOrEmpty(url)) {
                    window.location.href += `#${this.DefaultUrl}`;
                    return;
                }

                await this.Load(url);
            });
    };
}

export class Controler {
    public Content: JQuery; // Contenu HTML du controler
    private readonly Destination: JQuery; // Element HTML dans lequel le contenu va venir s'ajouter
    
    /**Inidique si le contenu doit être chargé.
     * Si false, émule directement le LoadCallBack.
     */
    #enableLoading = true;
    readonly #id: string;
    public IsPartial: boolean;
    readonly #loadCallBack?: (e: IControlerAfterLoadEvent) => void;
    #nom?: string;
    public Route: string;
    readonly #sourcePool: JQuery; // Container où se trouve le template
    readonly #title?: string;
    public DisposableStack = new DisposableStack();

    constructor(option: IControlerOption) {
        this.#nom = option.Nom;
        this.Route = option.Route;
        this.#title = option.Title;
        this.#id = option.Id;
        this.Destination = option.Destination;
        this.#loadCallBack = option.LoadCallBack;
        this.#sourcePool = option.SourcePool;
        this.IsPartial = (option.IsPartial == null) ? false : option.IsPartial;
        this.#enableLoading = (option.EnableLoading == null) ? true : option.EnableLoading;

        this.Content = this.#enableLoading == true ? this.Destination.find(`[circ-id='${this.#id}']`) : null;
    }

    /**
     * Charge le controller et en affiche le contenu.
     */
    public Load = async (url?: string, qs?: string): Promise<Controler> => {

        // Si le chargement est désactivé, on passe directement au callback.
        if (this.#enableLoading == false) {
            this.#endLoad(url).then();
            return this;
        }

        if (this.Destination == null)
            throw new Error("Le container de destination n'est pas défini");

        // Si le contenu n'existe pas : on le charge à partir de l'url

        await this.#getContent(url, qs).then(async (data: string) => {
            await this.#appendContent(data);
            this.#endLoad(url).then();
        });

        return this;

    };

    /**
     * Ajoute le contenu chargé dans le DOM
     */
    #appendContent = async (data: string) => {
        this.Destination.find(`[circ-id='${this.#id}']`).remove(); // Supprime le contenu s'il existe déjà.
        this.Destination.append(data);
        this.Content = this.Destination.find(`[circ-id='${this.#id}']`);
        this.#showContent().then();
    };

    #endLoad = async (url?: string) => {

        if (this.#enableLoading == true)
            this.#showContent().then();

        if (this.#loadCallBack != null)
            this.#loadCallBack({Url: url, Controler: this});

        if (String.IsNullOrEmpty(this.#title) == false) document.title = this.#title;
    };

    /*
    * Chargement du contenu depuis l'URL
    */
    #getContent = async (url?: string, qs?: string): Promise<string> => {

        if (String.IsNullOrEmpty(url)) url = this.Route;

        if (String.IsNullOrEmpty(qs) == false) {
            url += `?${qs}`;
        }

        if (!JQueryTools.Exists(this.#sourcePool))
            return null;

        const content = this.#sourcePool.find(`[circ-id='${this.#id}']`);
        if ((JQueryTools.Exists(content)))
            return content[0].outerHTML;
        
        return null;
    };

    #showContent = async () => {
        this.Content.show();
    };
}

export interface IControlerOption {
    Destination?: JQuery;
    EnableLoading?: boolean;
    Id: string;
    IsPartial?: boolean;
    LoadCallBack?: (e: IControlerAfterLoadEvent) => void;
    Nom?: string;
    Route: string;
    SourcePool?: JQuery;
    Title?: string;
}

export interface IControlerAfterLoadEvent {
    Controler: Controler;
    Url: string,
}
